import styled from 'styled-components';
import { fontSettings, transition } from '../../../styles';

export const SearchButton = styled.div<{
  hasSuggest: boolean;
  color: string;
}>`
  min-width: 200px;
  max-width: 400px;
  width: 100%;
  height: ${({ theme }): number => (theme.IS_MOBILE ? 48 : 54)}px;
  position: relative;
  box-sizing: border-box;
  background-color: ${(props): string => props.theme.COLOR.BLACK_4};
  border-radius: 100px;
  box-shadow: 0 5px 25px -5px rgba(12, 11, 13, 0.04);
  padding: 16px ${(props): string => (props.hasSuggest ? '46px' : '16px')} 16px
    20px;
  color: ${({ color }): string => color};
  ${(props): string =>
    fontSettings(props.theme.FONT.SIZE_17, props.theme.FONT)};
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: ${(props): string =>
    props.hasSuggest ? 'flex-start' : 'center'};
  cursor: pointer;
  ${transition('background-color')}

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  > svg {
    margin-right: 8px;
    flex: 0 0 24px;
  }

  &:hover {
    background-color: ${({ theme }): string => theme.COLOR.BLACK_08};
  }
`;

export const SearchButtonText = styled.div`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const SearchButtonClear = styled.div<{ visibleClearControl: boolean }>`
  display: ${({ visibleClearControl }): string =>
    visibleClearControl ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  border: none;
  background: ${({ theme }): string => theme.COLOR.TEXT_LIGHT_COLOR};
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 19px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  padding: 0;
  opacity: 0.64;
  transition: opacity 0.1s ease-in-out;

  :hover {
    opacity: 1;
  }
`;
